import React from 'react'
import Styles from '../Footer/footer-component.module.scss'
import logo1 from '../../../assets/logo-setdig-branca.svg'
import logo from '../../../assets/Logo.png'
const Footer:React.FC<any> = () =>{
  return (
    <>
        <footer className={Styles.footer}>
          <img src={logo} className={Styles.img}></img>
          <div className={Styles.imgs}>
            <img src={logo1} className={Styles.img3}></img>
          </div>
        </footer>
    </>
  )
}

export default Footer;
